import Generator from "./pages/Generator/Generator";

function App() {
  return (
    <>
      <Generator />
    </>
  );
}

export default App;
